<script>
import Endpoints from '../../../../components/common/Endpoints';
import Common from '../../../../components/common/Common';
import Request from '../../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: async(payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
         
    },
    methods:{
      filter: async function(){
       let responseOrderHolderCertifieds = (await Request.do(this, 'POST', Request.getDefaultHeader(this), {typeOrder: ["CERTIFIEDS"]}, `${Endpoints.orders.holder.listOrderByDate}`)).data;
       let responseOrderHolderParts = (await Request.do(this, 'POST', Request.getDefaultHeader(this), {typeOrder: ["PARTS"]}, `${Endpoints.orders.holder.listOrderByDate}`)).data;
       let responseOrderHolderServices = (await Request.do(this, 'POST', Request.getDefaultHeader(this), {typeOrder: ["SERVICES"]}, `${Endpoints.orders.holder.listOrderByDate}`)).data;
       let responseOrderHolder = (await Request.do(this, 'POST', Request.getDefaultHeader(this), {typeOrder: ["CERTIFIEDS","PARTS","SERVICES"]}, `${Endpoints.orders.holder.listOrderByDate}`)).data;

        if (responseOrderHolderCertifieds.status==200 && responseOrderHolderParts.status==200 && responseOrderHolderServices.status==200){

              const data = new Date();
              responseOrderHolder.date = new Date(data).toLocaleDateString();

              this.chart.data.labels = [responseOrderHolder.results[0]._id];

              for(var i = 1; i < responseOrderHolder.results.length; i++){
                  this.chart.data.labels[i] = responseOrderHolder.results[i]._id;
                }

                this.chart.data.datasets[0].data = [responseOrderHolderCertifieds.results[0].nOrders];
                this.chart.data.datasets[1].data = [responseOrderHolderParts.results[0].nOrders];
                this.chart.data.datasets[2].data = [responseOrderHolderServices.results[0].nOrders];

                this.totalCertifieds = responseOrderHolderCertifieds.results[0].nOrders;
                this.totalParts = responseOrderHolderParts.results[0].nOrders;
                this.totalServices = responseOrderHolderServices.results[0].nOrders;

                for(var j = 1; j < responseOrderHolderCertifieds.results.length; j++){
                   this.chart.data.datasets[0].data[j] = [responseOrderHolderCertifieds.results[j].nOrders];
                   this.totalCertifieds += responseOrderHolderCertifieds.results[j].nOrders;
                }

                for(var k = 1; k < responseOrderHolderParts.results.length; k++){
                   this.chart.data.datasets[1].data[k] = [responseOrderHolderParts.results[k].nOrders];
                   this.totalParts += responseOrderHolderParts.results[k].nOrders;
                }

                for(var l = 1; l < responseOrderHolderCertifieds.results.length; l++){
                   this.chart.data.datasets[2].data[l] = [responseOrderHolderServices.results[l].nOrders];
                   this.totalServices +=responseOrderHolderServices.results[l].nOrders;
                }


              this.chart.update();
        }
      }
    }
}
</script>